import { render, staticRenderFns } from "./FrmWelcome.vue?vue&type=template&id=8c7d837e&scoped=true"
import script from "./FrmWelcome.vue?vue&type=script&lang=js"
export * from "./FrmWelcome.vue?vue&type=script&lang=js"
import style0 from "./FrmWelcome.vue?vue&type=style&index=0&id=8c7d837e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d837e",
  null
  
)

export default component.exports